import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { VsxIcon } from "vue-iconsax";
import LazyLoad from "./utils/LazyLoad";
import axios from "axios";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import myHelper from "./mixins/helper.js";
import store from "./store";
import "./assets/styles/home.scss";
import "./App.css";

const app = createApp(App);

app.use(VueSweetalert2);
app.use(ElementPlus);
app.use(router);
app.use(store);
app.mixin(myHelper);
app.config.globalProperties.$axios = axios;
app.component("VsxIcon", VsxIcon);
app.directive("lazy", LazyLoad);

app.mount("#app");
